module.exports = __webpack_public_path__ + "img/facebook-square.fb99c050.svg";